<div class="At-ProfilePage">
  <div class="At-PageHeading">
    <h2>profile</h2>
    <div class="At-RightBox">
      <button type="button" class="At-EditBtn" (click)="selectTab(1)"><i class="icon-edit"></i> edit profile</button>
      <!-- <div class="At-BtnArea">
        <button type="button" class="mr-4">save changes</button>
        <button type="button" class="At-BgGrey">cancel</button>
      </div> -->
    </div>
  </div>
  <div class="At-ProfileContentArea">
      <aside class="At-TabsSideBar">
        <ul>
          <li><button type="button" class="At-TabsBtn active" (click)="selectTab(0)" (click)="onClick(1)" [ngClass]="{'active': tab==='tab1'}"><i class="icon-profile"></i>Personal Information</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(2)" (click)="onClick(2)" [ngClass]="{'active': tab==='tab2'}"><i class="icon-gallery"></i>Media</button></li>
          <li><button type="button" class="At-TabsBtn" (click)="selectTab(3)" (click)="onClick(3)" [ngClass]="{'active': tab==='tab3'}"><i class="icon-users"></i>My Contacts</button></li>
        </ul>
      </aside>
      <div class="At-TabContent At-CustomScroll">
        <tabset #staticTabs>
          <tab heading="0">
            <app-view-profile></app-view-profile>
          </tab>
          <tab heading="1">
            <app-edit-profile></app-edit-profile>
          </tab>
          <tab heading="2">
            <app-profile-media></app-profile-media>
          </tab>
          <tab heading="3">
            <app-mycontacts></app-mycontacts>
          </tab>
        </tabset>
      </div>
  </div>
</div>
